import loadingConstants from '../constants/loading';

const toggleLoading = (isLoading) => ({
  type: loadingConstants.TOGGLE_LOADING,
  isLoading
})

export const toggleIsLoading = (isLoading) => {
  return (dispatch) => {
    dispatch(toggleLoading(isLoading));
  }
}



/** WEBPACK FOOTER **
 ** ./src/actions/loading.js
 **/